export default class InspectorControl {
  constructor(config = {}) {
    this.icon = config.icon || 'question';
    this.title = config.title || '';
    this.route = config.route || null;
  }
}
